{
	"app_sidebar": {
		"menu": {
			"theme": "Theme"
		},
		"theme": {
			"dark": "Dark",
			"light": "Light",
			"system": "System"
		}
	},
	"async_pickers": {
		"selected_count_one": "1 selected",
		"selected_count_other": "{{count}} selected"
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Autosize this column",
			"clear_sort": "Clear sort",
			"hide_column": "Hide column",
			"no_pin": "No pin",
			"pin_column": "Pin column",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"sort_asc": "Sort ascending",
			"sort_desc": "Sort descending",
			"trigger": "Column options for {{column}}"
		},
		"column_settings": {
			"drag_handle": "Reorder column",
			"no_results": "No columns match",
			"pin_column": "Pin {{column}}",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"reset": "Reset",
			"search_placeholder": "Search columns...",
			"show_all": "Show all",
			"toggle_visibility": "Toggle {{column}}",
			"trigger": "Columns",
			"unpin": "Unpin"
		},
		"error": "Failed to load data",
		"loading_more": "Loading more...",
		"no_results": "No results",
		"pagination": {
			"go_to_page": "Go to page {{page}}",
			"more_pages": "More pages",
			"next": "Next",
			"previous": "Previous",
			"rows_per_page": "Rows per page"
		},
		"select_all": "Select all rows",
		"select_row": "Select row",
		"sort_by": "Sort by {{column}}"
	},
	"http_errors": {
		"admin_forbidden": "You don't have permission to perform this admin action.",
		"anonymous_sign_in_disabled": "Anonymous sign-in is disabled.",
		"anonymous_user_cannot_change_password": "Anonymous users cannot change their password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Anonymous users can't sign in anonymously again.",
		"apple_mobile_deep_link_not_allowed": "Apple mobile sign-in links are not allowed.",
		"apple_mobile_ott_invalid": "The Apple mobile sign-in token is invalid.",
		"apple_mobile_sign_in_failed": "Apple mobile sign-in failed.",
		"auth_credentials_missing": "Sign in before continuing.",
		"auth_csrf_invalid": "Your session security token is invalid. Refresh and try again.",
		"auth_email_not_found": "No account with this email address could be found.",
		"auth_jwt_invalid": "Your sign-in session is invalid or has expired. Sign in again.",
		"auth_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"auth_token_invalid": "Your sign-in session is invalid or has expired. Start again.",
		"backoffice_admin_deleted": "This admin account has been deleted.",
		"backoffice_admin_disabled": "This admin account is disabled. Contact an administrator.",
		"backoffice_admin_not_found": "This admin account could not be found.",
		"backoffice_auth_credentials_missing": "Sign in as an admin before continuing.",
		"backoffice_auth_token_invalid": "Your sign-in session is invalid or has expired. Start again.",
		"backoffice_challenge_not_found": "The admin authentication challenge could not be found.",
		"backoffice_change_password_otp_invalid": "The email code is invalid. Please try again.",
		"backoffice_change_password_otp_unavailable": "Email codes are not available for changing this admin password.",
		"backoffice_change_password_totp_invalid": "The authenticator code is invalid. Please try again.",
		"backoffice_csrf_invalid": "Your admin session security token is invalid. Refresh and try again.",
		"backoffice_disable_two_factor_method_not_available": "No available method can disable two-factor authentication for this admin account.",
		"backoffice_disable_two_factor_otp_invalid": "The email code is invalid. Please try again.",
		"backoffice_disable_two_factor_otp_unavailable": "Email codes are not available for disabling two-factor authentication on this admin account.",
		"backoffice_disable_two_factor_passkey_invalid": "Passkey verification failed. Please try again.",
		"backoffice_disable_two_factor_recovery_code_invalid": "The recovery code is invalid. Please try again.",
		"backoffice_disable_two_factor_totp_invalid": "The authenticator code is invalid. Please try again.",
		"backoffice_email_already_in_use": "An admin account with this email already exists.",
		"backoffice_email_change_token_invalid": "The admin email change session is invalid or has expired.",
		"backoffice_email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"backoffice_failed_to_verify_registration": "The admin passkey registration could not be verified.",
		"backoffice_invalid_code": "The code is invalid.",
		"backoffice_invalid_email_or_password": "The email or password is invalid.",
		"backoffice_invalid_password": "The password is invalid.",
		"backoffice_invite_invalid": "This admin invitation is invalid or has expired.",
		"backoffice_jwt_invalid": "Your admin session is invalid or has expired. Sign in again.",
		"backoffice_mfa_challenge_invalid": "Your verification session has expired. Sign in again.",
		"backoffice_mfa_challenge_required_for_change_password": "Verify your identity before changing this admin password.",
		"backoffice_mfa_device_limit_reached": "This admin account has reached the two-factor device limit.",
		"backoffice_mfa_email_otp_not_available": "Email verification codes aren't available for this account.",
		"backoffice_mfa_enrollment_expired": "Two-factor setup has expired. Start again.",
		"backoffice_mfa_invalid_backup_code": "The backup code is invalid. Please try again.",
		"backoffice_mfa_invalid_email_otp": "The email code is invalid. Please try again.",
		"backoffice_mfa_invalid_passkey": "Passkey verification failed. Please try again.",
		"backoffice_mfa_invalid_totp_code": "The authenticator code is invalid. Please try again.",
		"backoffice_mfa_not_enabled": "Two-factor authentication is not enabled for this admin account.",
		"backoffice_mfa_passkey_not_available": "Passkey verification is not available for this admin account.",
		"backoffice_new_email_same_as_current": "The new admin email matches the current email.",
		"backoffice_no_change_password_method_available": "No available method can change this admin password.",
		"backoffice_passkey_authentication_failed": "Admin passkey authentication failed.",
		"backoffice_passkey_limit_reached": "This admin account has reached the passkey limit.",
		"backoffice_passkey_not_found": "This admin passkey could not be found.",
		"backoffice_rate_limited_one": "Too many attempts: try again in {{count}} minute.",
		"backoffice_rate_limited_other": "Too many attempts: try again in {{count}} minutes.",
		"backoffice_reset_password_session_missing": "The admin password reset session is missing.",
		"backoffice_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"backoffice_self_edit_forbidden": "You cannot edit your own admin account here.",
		"backoffice_session_expired": "Your admin session has expired. Sign in again.",
		"backoffice_session_invalid": "Your admin session is no longer valid. Sign in again.",
		"backoffice_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"backoffice_social_not_registered": "No admin account is registered for this social sign-in.",
		"backoffice_totp_authenticator_not_found": "This admin authenticator could not be found.",
		"backoffice_you_are_not_allowed_to_register_this_passkey": "You are not allowed to register this admin passkey.",
		"challenge_not_found": "The authentication challenge could not be found.",
		"change_password_otp_invalid": "The email code is invalid. Please try again.",
		"change_password_otp_unavailable": "Email codes are not available for changing this password.",
		"change_password_totp_invalid": "The authenticator code is invalid. Please try again.",
		"default": "Oops! Something went wrong.",
		"disable_two_factor_method_not_available": "No available method can disable two-factor authentication for this account.",
		"disable_two_factor_otp_invalid": "The email code is invalid. Please try again.",
		"disable_two_factor_otp_unavailable": "Email codes are not available for disabling two-factor authentication on this account.",
		"disable_two_factor_passkey_invalid": "Passkey verification failed. Please try again.",
		"disable_two_factor_recovery_code_invalid": "The recovery code is invalid. Please try again.",
		"disable_two_factor_totp_invalid": "The authenticator code is invalid. Please try again.",
		"email_already_in_use": "An account with this email already exists.",
		"email_change_token_invalid": "The email change session is invalid or has expired.",
		"email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"export_not_found": "This export could not be found.",
		"export_too_large_for_sync": "This export is too large for direct download. Use auto or email when ready.",
		"failed_to_verify_registration": "The registration could not be verified.",
		"impersonation_token_invalid": "This impersonation link is invalid or has already expired.",
		"invalid_code": "The code is invalid.",
		"invalid_delete_account_otp": "The account deletion code is invalid.",
		"invalid_email_or_password": "The email or password is invalid.",
		"invalid_password": "The password is invalid.",
		"last_social_account_without_email": "Add an email address before unlinking your last social account.",
		"maintenance_mode": "The service is temporarily in maintenance mode.",
		"mfa_challenge_invalid": "Your verification session has expired. Sign in again.",
		"mfa_challenge_required_for_change_password": "Verify your identity before changing your password.",
		"mfa_device_limit_reached": "This account has reached the two-factor device limit.",
		"mfa_email_otp_not_available": "Email verification codes aren't available for this account.",
		"mfa_enrollment_expired": "Two-factor setup has expired. Start again.",
		"mfa_invalid_backup_code": "The backup code is invalid. Please try again.",
		"mfa_invalid_email_otp": "The email code is invalid. Please try again.",
		"mfa_invalid_passkey": "Passkey verification failed. Please try again.",
		"mfa_invalid_totp_code": "The authenticator code is invalid. Please try again.",
		"mfa_not_enabled": "Two-factor authentication is not enabled for this account.",
		"mfa_passkey_not_available": "Passkey verification is not available for this account.",
		"mfa_requires_identity": "Verify your identity before managing two-factor authentication.",
		"new_email_same_as_current": "The new email matches the current email.",
		"no_change_password_method_available": "No available method can change this password.",
		"otp_issuance_throttled": "Too many code requests. Please wait before requesting a new one.",
		"passkey_authentication_failed": "Passkey authentication failed.",
		"passkey_limit_reached": "This account has reached the passkey limit.",
		"passkey_not_found": "The passkey could not be found.",
		"password_too_long": "The password is too long.",
		"password_too_short": "The password is too short.",
		"permission_denied": "Your account is signed in, but it doesn't have the permissions required to view this page.",
		"reset_password_session_missing": "The password reset session is missing.",
		"reset_password_token_invalid": "The password reset token is invalid or expired.",
		"session_expired": "Your session has expired. Sign in again.",
		"session_invalid": "Your session is no longer valid. Sign in again.",
		"session_not_found": "This session could not be found.",
		"social_account_already_linked": "This social account is already linked.",
		"social_code_exchange_failed": "Social sign-in could not be completed. Please try again.",
		"social_email_not_verified": "The social account email address is not verified.",
		"social_provider_not_configured": "This social sign-in provider is not configured.",
		"social_redirect_uri_not_allowed": "This social sign-in redirect is not allowed.",
		"social_token_invalid": "The social sign-in token is invalid or expired.",
		"totp_authenticator_not_found": "This authenticator could not be found.",
		"unauthorized": "You're not signed in. Please log in to continue.",
		"user_already_has_provider_linked": "This user already has that provider linked.",
		"user_banned": "This user account has been banned.",
		"user_deleted": "This user account has been deleted.",
		"user_not_found": "This user could not be found.",
		"validation_error": "Some of the information you entered is invalid.",
		"you_are_not_allowed_to_register_this_passkey": "You're not allowed to register this passkey."
	},
	"inline_filters": {
		"clear": "Clear filter",
		"clear_all": "Clear all"
	},
	"input_password": {
		"hide": "Hide password",
		"show": "Show password"
	},
	"list_input_search": {
		"label": "Search",
		"clear": "Clear search"
	},
	"query_breadcrumbs": {
		"error": "Error",
		"no_data": "Detail"
	},
	"two_factor_device_picker": {
		"device_label": "Authenticator device",
		"device_unnamed": "Unnamed device"
	},
	"sidebar": {
		"close": "Close menu",
		"open": "Open menu"
	}
}
